var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.784 5.459C14.8566 7.61496 15.2406 10.0485 14.884 12.43L12.36 12.53L1 13L7.076 3.182L8.426 1C10.6365 1.88592 12.5113 3.44622 13.784 5.459Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    d: "M12.3621 12.533C12.4182 10.5996 11.9481 8.68717 11.0021 7.00001C10.089 5.37611 8.72641 4.05037 7.07812 3.18201",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.77344 10.23C9.49774 10.23 9.27344 10.0057 9.27344 9.72998C9.27344 9.45428 9.49774 9.22998 9.77344 9.22998C10.0491 9.22998 10.2734 9.45428 10.2734 9.72998C10.2734 10.0057 10.0491 10.23 9.77344 10.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.77344 8.72998C10.3257 8.72998 10.7734 9.1777 10.7734 9.72998C10.7734 10.2823 10.3257 10.73 9.77344 10.73C9.22116 10.73 8.77344 10.2823 8.77344 9.72998C8.77344 9.1777 9.22116 8.72998 9.77344 8.72998Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.28906 10.799C5.01336 10.799 4.78906 10.5747 4.78906 10.299C4.78906 10.0233 5.01336 9.79895 5.28906 9.79895C5.56476 9.79895 5.78906 10.0233 5.78906 10.299C5.78906 10.5747 5.56476 10.799 5.28906 10.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M5.28906 9.29895C5.84134 9.29895 6.28906 9.74667 6.28906 10.299C6.28906 10.8512 5.84134 11.299 5.28906 11.299C4.73678 11.299 4.28906 10.8512 4.28906 10.299C4.28906 9.74667 4.73678 9.29895 5.28906 9.29895Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M7.77344 7.22998C7.49774 7.22998 7.27344 7.00568 7.27344 6.72998C7.27344 6.45428 7.49774 6.22998 7.77344 6.22998C8.04914 6.22998 8.27344 6.45428 8.27344 6.72998C8.27344 7.00568 8.04914 7.22998 7.77344 7.22998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M7.77344 5.72998C8.32572 5.72998 8.77344 6.1777 8.77344 6.72998C8.77344 7.28226 8.32572 7.72998 7.77344 7.72998C7.22116 7.72998 6.77344 7.28226 6.77344 6.72998C6.77344 6.1777 7.22116 5.72998 7.77344 5.72998Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.f0742ebf2f794a964fb4c419a282c786.svg";
export { ForwardRef as ReactComponent };